import { Client } from "./client";
import { RequirementsListResponse, RequirementResponse, CreateRequirementRequest } from "@/backend/express/controllers/requirements/requirementsController";
import { FusaReply } from "@/types/replyTypes";
import { useGlobalStore } from "@/frontend/store/GlobalStore";
import { FusaToastType } from "@/frontend/toasts/types";
import { I18n } from "@/i18n/I18n";
import { RequirementSubjectType } from "@/backend/access/requirement/types";

export class RequirementFrontendController {
  client: Client;

  constructor(client?: Client) {
    this.client = client || new Client();
  }

  getRequirementsBySubject(subjectId: string, subjectType: RequirementSubjectType): Promise<RequirementsListResponse> {
    return this.client.read(`/api/requirements/subject/${subjectType}/${subjectId}`);
  }

  getRequirement(id: string): Promise<RequirementResponse> {
    return this.client.read(`/api/requirements/${id}`);
  }

  async createRequirement(data: CreateRequirementRequest): Promise<RequirementResponse> {
    const response = await this.client.create('/api/requirements', data);
    
    if (response.status === 201 && response.requirement) {
      useGlobalStore.getState().addToast({
        type: FusaToastType.SUCCESS,
        message: I18n.get('modelCreated', { model: I18n.get('requirementUppercase'), title: response.requirement.name }),
        header: I18n.get('success'),
        autohide: true
      });
    }
    
    return response;
  }

  updateRequirement(id: string, data: Partial<CreateRequirementRequest>): Promise<RequirementResponse> {
    return this.client.update(`/api/requirements/${id}`, data);
  }

  updateAssignedSupplierUserId(id: string, assignedSupplierUserId: string | null): Promise<RequirementResponse> {
    return this.client.update(`/api/requirements/${id}/assigned-supplier-user`, { assignedSupplierUserId });
  }

  async deleteRequirement(id: string): Promise<FusaReply> {
    const response = await this.client.delete(`/api/requirements/${id}`);
    
    if (response.status === 200) {
      useGlobalStore.getState().addToast({
        type: FusaToastType.SUCCESS,
        message: I18n.get('modelRemoved', { model: I18n.get('requirementUppercase') }),
        header: I18n.get('success'),
        autohide: true
      });
    }
    
    return response;
  }
}
